import MaterialIcon from "../../../../MaterialIcon";
import React from "react";

export const AddInputButton = (props) => {
    const {onClick, label} = props;
    return (
        <div className="bottom-button-area">
            <button className="add-button" onClick={onClick}><MaterialIcon icon="add_circle"/>{label ?? "Add Modifier"}
            </button>
        </div>
    )
}